import React, { useState, useEffect } from 'react';
import "../../../Adm/Editar/EditarFornecedor/EditarFornecedor.css";
import { Form, Input, Button, Select, message } from 'antd';
import { UserOutlined, PhoneOutlined, MailOutlined, HomeOutlined, LockOutlined, ArrowLeftOutlined } from '@ant-design/icons';
import { useParams, useNavigate } from 'react-router-dom';
import ProtectedRoute from '../../../../components/ProtectedRoute';
import api from '../../../../services/api';
import API_CONFIG from '../../../../config/api.config';

const { Option } = Select;

const initialState = {
  nome: '',
  telefone: '',
  email: '',
  cep: '',
  logradouro: '',
  numero: '',
  bairro: '',
  cidade: '',
  estado: '',
  tipoUsuario: '',
  fornecedor: '',
  prefeitura: '',
  login: '',
  senha: '',
};

const EditarUsuario = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [form, setForm] = useState(initialState);
  const [errors, setErrors] = useState({});
  const [touched, setTouched] = useState({});
  const [submitted, setSubmitted] = useState(false);
  const [isMenuExpanded, setIsMenuExpanded] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [fornecedores, setFornecedores] = useState([]);
  const [prefeituras, setPrefeituras] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const handleMenuChange = (event) => {
      setIsMenuExpanded(!event.detail.isCollapsed);
    };
    window.addEventListener('menuStateChange', handleMenuChange);
    return () => window.removeEventListener('menuStateChange', handleMenuChange);
  }, []);

  useEffect(() => {
    carregarDadosUsuario();
  }, [id]);

  useEffect(() => {
    const token = localStorage.getItem('token');
    const tipoUsuario = localStorage.getItem('tipoUsuario');
    const idUsuario = localStorage.getItem('idUsuario');

    if (!token || !tipoUsuario || !idUsuario) {
      message.error('Sessão expirada. Por favor, faça login novamente.');
      navigate('/');
      return;
    }
  }, [navigate]);

  const carregarDadosUsuario = async () => {
    try {
      setLoading(true);
      const response = await api.get(API_CONFIG.ENDPOINTS.USUARIOS.CONSULTAR_USUARIO(id));
      
      if (response.data.status) {
        const usuarioData = response.data.usuario;
        setForm({
          id: usuarioData.USU_ID,
          nome: usuarioData.USU_NOME,
          telefone: usuarioData.USU_TELEFONE,
          email: usuarioData.USU_EMAIL,
          cep: usuarioData.endereco?.END_CEP || '',
          logradouro: usuarioData.endereco?.END_LOGRADOURO || '',
          numero: usuarioData.endereco?.END_NUMERO || '',
          bairro: usuarioData.endereco?.END_BAIRRO || '',
          cidade: usuarioData.endereco?.END_CIDADE || '',
          estado: usuarioData.endereco?.END_ESTADO || '',
          tipoUsuario: usuarioData.USU_TIPO,
          fornecedor: usuarioData.USU_FOR_ID || '',
          prefeitura: usuarioData.USU_PRE_ID || '',
          login: usuarioData.USU_LOGIN,
          senha: ''
        });
      } else {
        message.error('Erro ao carregar dados do usuário');
      }
    } catch (error) {
     // console.error('Erro ao carregar dados do usuário:', error);
      message.error('Erro ao carregar dados do usuário');
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    let formattedValue = value;

    if (name === 'telefone') {
      formattedValue = formatarTelefone(value);
    }

    setForm({ ...form, [name]: formattedValue });
    setTouched({ ...touched, [name]: true });
  };

  const formatarTelefone = (valor) => {
    const numbers = valor.replace(/\D/g, '');
    if (numbers.length <= 11) {
      if (numbers.length <= 2) {
        return numbers;
      } else if (numbers.length <= 6) {
        return `(${numbers.slice(0, 2)}) ${numbers.slice(2)}`;
      } else if (numbers.length <= 10) {
        return `(${numbers.slice(0, 2)}) ${numbers.slice(2, 6)}-${numbers.slice(6)}`;
      } else {
        return `(${numbers.slice(0, 2)}) ${numbers.slice(2, 7)}-${numbers.slice(7, 11)}`;
      }
    }
    return valor;
  };

  const validate = () => {
    const newErrors = {};
    if (!form.nome) newErrors.nome = 'Campo obrigatório';
    if (!form.tipoUsuario) newErrors.tipoUsuario = 'Campo obrigatório';
    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitted(true);
    const validationErrors = validate();
    setErrors(validationErrors);
    
    if (Object.keys(validationErrors).length === 0) {
      try {
        setLoading(true);
        const dadosParaEnviar = {
          USU_NOME: form.nome,
          USU_TIPO: form.tipoUsuario,
          USU_STATUS: 'ATIVO'
        };

        // Só envia a senha se ela foi alterada e não está vazia
        if (form.senha && form.senha.trim() !== '') {
          dadosParaEnviar.USU_SENHA = form.senha;
        }

        //console.log('Dados sendo enviados:', dadosParaEnviar);

        const response = await api.put(API_CONFIG.ENDPOINTS.USUARIOS.ATUALIZAR_USUARIO(id), dadosParaEnviar);

        if (response.data.status) {
          message.success('Usuário atualizado com sucesso!');
          navigate('/adm/gerenciar/usuario');
        } else {
          message.error(response.data.message || 'Erro ao atualizar usuário');
        }
      } catch (error) {
       // console.error('Erro ao atualizar usuário:', error);
        if (error.response?.data) {
         // console.error('Detalhes do erro:', error.response.data);
          message.error(error.response.data.message || 'Erro ao atualizar usuário');
        } else {
          message.error('Erro ao atualizar usuário');
        }
      } finally {
        setLoading(false);
      }
    }
  };

  const showError = (field) => (submitted || touched[field]) && errors[field];

  const buscarEnderecoPorCEP = async (cep) => {
    try {
      const response = await fetch(`https://viacep.com.br/ws/${cep}/json/`);
      const data = await response.json();
      if (!data.erro) {
        setForm({
          ...form,
          logradouro: data.logradouro,
          bairro: data.bairro,
          cidade: data.localidade,
          estado: data.uf
        });
      } else {
        message.error('CEP não encontrado');
      }
    } catch (error) {
      message.error('Erro ao buscar CEP');
    }
  };

  const handleVoltar = () => {
    const token = localStorage.getItem('token');
    const tipoUsuario = localStorage.getItem('tipoUsuario');
    const idUsuario = localStorage.getItem('idUsuario');

    if (!token || !tipoUsuario || !idUsuario) {
      message.error('Sessão expirada. Por favor, faça login novamente.');
      navigate('/');
      return;
    }

    navigate('/adm/gerenciar/usuario');
  };

  if (loading) {
    return <div>Carregando...</div>;
  }

  return (
    <ProtectedRoute tipoPermitido="ADM">
    <div className={`home-container ${isMenuExpanded ? 'menu-expanded' : ''}`}>
      <div className="modal-wrapper">
        <div className="modal-header">
          <h1 className="modal-title">Editar Usuário</h1>
        </div>
        <div className="modal-content">
          <form className="form-usuario" onSubmit={handleSubmit} autoComplete="off">
            <div className="form-row">
              <div className="form-group">
                <label className="form-label">Nome <span className="asterisco-obrigatorio">*</span></label>
                <input
                  type="text"
                  name="nome"
                  placeholder="Nome completo"
                  value={form.nome}
                  onChange={handleChange}
                  className={showError('nome') ? 'erro' : ''}
                />
                {showError('nome') && <span className="msg-erro">{errors.nome}</span>}
              </div>
              <div className="form-group">
                <label className="form-label">Telefone</label>
                <input
                  type="text"
                  name="telefone"
                  placeholder="(00) 00000-0000"
                  value={form.telefone}
                  onChange={handleChange}
                  className={showError('telefone') ? 'erro' : ''}
                  maxLength="15"
                />
                {showError('telefone') && <span className="msg-erro">{errors.telefone}</span>}
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label className="form-label">Tipo de Usuário <span className="asterisco-obrigatorio">*</span></label>
                <select
                  name="tipoUsuario"
                  value={form.tipoUsuario}
                  onChange={handleChange}
                  className={`${showError('tipoUsuario') ? 'erro' : ''} input-menor`}
                >
                  <option value="">Selecione o Tipo</option>
                  <option value="ADM">Administrador</option>
                  <option value="PRE">Prefeitura</option>
                  <option value="FOR">Fornecedor</option>
                </select>
                {showError('tipoUsuario') && <span className="msg-erro">{errors.tipoUsuario}</span>}
              </div>
            </div>

            <label className="form-label">Dados de Acesso:</label>
            <div className="form-row">
              <div className="form-group">
                <label className="form-label">Login</label>
                <input
                  type="text"
                  name="login"
                  placeholder="Login"
                  value={form.login}
                  readOnly
                  disabled
                  style={{ backgroundColor: '#f5f5f5' }}
                />
              </div>
              <div className="form-group">
                <label className="form-label">Senha</label>
                <div className="password-input-container">
                  <input
                    type={showPassword ? "text" : "password"}
                    name="senha"
                    placeholder="Senha"
                    value={form.senha}
                    onChange={handleChange}
                  />
                  <button
                    type="button"
                    className="toggle-password"
                    onClick={() => setShowPassword(!showPassword)}
                    title={showPassword ? "Ocultar senha" : "Mostrar senha"}
                  >
                    {showPassword ? "👁️" : "👁️‍🗨️"}
                  </button>
                </div>
              </div>
            </div>
            <div className="form-actions">
              <Button
                className="submit-button"
                type="primary"
                icon={<ArrowLeftOutlined />}
                onClick={handleVoltar}
                style={{ minWidth: 120, fontWeight: 500, background: '#001f4d', border: 'none' }}
              >
                Voltar
              </Button>
              <Button 
                type="primary" 
                htmlType="submit" 
                className="submit-button" 
                style={{ minWidth: 140 }}
                loading={loading}
              >
                Salvar
              </Button>
            </div>
          </form>
        </div>
      </div>
    </div>
    </ProtectedRoute>
  );
};

export default EditarUsuario;